module.exports = __webpack_public_path__ + "img/near6.c428a9c3.jpg";